module.exports = __webpack_public_path__ + "img/grass.86dbf014.jpg";